/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/10-github-repositories-javascript",
  title: "10 GitHub repositories - Javascript",
  description: `10 GitHub repositories that will take your Javascript knowledge to the next level (I bet).

Thread 🧵👇`,
  image: "/covers/threads/10-github-repositories-javascript.png",
  author: "Csaba Kissi"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Csaba Kissi",
      username: "csaba_kissi",
      avatarUrl: "/avatars/csaba_kissi.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/csaba_kissi/status/1589976769888542720"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `/images/10-github-repositories-javascript-0.png`,
      children: [_jsx(_components.p, {
        children: "10 GitHub repositories that will take your Javascript knowledge to the next level (I bet)."
      }), _jsx(_components.p, {
        children: "Thread 🧵👇"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [1, " JavaScript Style Guide by Airbnb"]
      }), _jsx(_components.p, {
        children: "JavaScript Style Guide."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/airbnb/javascript",
          children: "https://github.com/airbnb/javascript"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [2, " You-Dont-Know-JS"]
      }), _jsx(_components.p, {
        children: "A book series on JavaScript"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/getify/you-dont-know-js",
          children: "https://github.com/getify/you-dont-know-js"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [3, " 30-Days-Of-JavaScript"]
      }), _jsx(_components.p, {
        children: "30 days of JavaScript programming challenge is a step-by-step guide to learning JavaScript programming language in 30 days."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/asabeneh/30-days-of-javascript",
          children: "https://github.com/asabeneh/30-days-of-javascript"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [4, " Clean-code-javascript"]
      }), _jsx(_components.p, {
        children: "Clean Code concepts adapted for JavaScript"
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/ryanmcdermott/clean-code-javascript",
          children: "https://github.com/ryanmcdermott/clean-code-javascript"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [5, " 33-js-concepts"]
      }), _jsx(_components.p, {
        children: "📜 33 JavaScript concepts every developer should know."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/leonardomso/33-js-concepts",
          children: "https://github.com/leonardomso/33-js-concepts"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [6, " awesome-javascript"]
      }), _jsx(_components.p, {
        children: "🐢 A collection of excellent browser-side JavaScript libraries, resources, and shiny things."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/sorrycc/awesome-javascript",
          children: "https://github.com/sorrycc/awesome-javascript"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [7, " Javascript-questions"]
      }), _jsx(_components.p, {
        children: "A long list of (advanced) JavaScript questions, and their explanations."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/lydiahallie/javascript-questions",
          children: "https://github.com/lydiahallie/javascript-questions"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [8, " Javascript-algorithms"]
      }), _jsx(_components.p, {
        children: "📝 Algorithms and data structures implemented in JavaScript with explanations and links to further readings."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/trekhleb/javascript-algorithms",
          children: "https://github.com/trekhleb/javascript-algorithms"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [9, " 30-seconds-of-code"]
      }), _jsx(_components.p, {
        children: "Short JavaScript code snippets for all your development needs."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/30-seconds/30-seconds-of-code",
          children: "https://github.com/30-seconds/30-seconds-of-code"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: [10, " Awesome-JavaScript-Projects"]
      }), _jsx(_components.p, {
        children: "This Repository contains awesome vanilla JavaScript projects."
      }), _jsxs(_components.p, {
        children: ["🔗 ", _jsx(_components.a, {
          href: "https://github.com/vishal-raj-1/awesome-javascript-projects",
          children: "https://github.com/vishal-raj-1/awesome-javascript-projects"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "You can bookmark this tweet by replying with @SaveToBookmarks #javascript #github"
      }), _jsx(_components.p, {
        children: "You can even unroll the full thread by replying with @SaveToBookmarks unroll"
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "If you want to receive a summary of my best resources you can even subscribe to my weekly newsletter:\ncsabakissi.com/nl"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "That's all, guys."
      }), _jsx(_components.p, {
        children: "If you found this list useful, consider:"
      }), _jsx(_components.p, {
        children: "✅ Follow @csaba_kissi for more content like this"
      }), _jsx(_components.p, {
        children: "🔔 Enable notifications 👀"
      }), _jsx(_components.p, {
        children: "🔄 Retweeting the first tweet."
      }), _jsx(_components.p, {
        children: "Thanks for your support guys! 🙏🤝"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
